module.exports = __webpack_public_path__ + "static/media/Mirrage-Nautic-Club.e497a75a.pdf";